/* Project Import will be here */
import {
  getErrorObject,
  normalize
} from "utilities/utils";
import { getAnyTokenFromState } from "services/index";
import { getChannelsApi, getSubChannelsApi } from "services/channel";
import { IChannelParams, ISubChannelParams, ISubChannelActionParams } from "models/channelModels";
/* Project Import will be here */

export const types = {
  LOAD_CHANNEL_REQUEST: "channel/LOAD_CHANNEL_REQUEST",
  LOAD_CHANNEL_SUCCESS: "channel/LOAD_CHANNEL_SUCCESS",
  LOAD_CHANNEL_FAILURE: "channel/LOAD_CHANNEL_FAILURE",
  LOAD_SUB_CHANNEL_REQUEST: "channel/LOAD_SUB_CHANNEL_REQUEST",
  LOAD_SUB_CHANNEL_SUCCESS: "channel/LOAD_SUB_CHANNEL_SUCCESS",
  LOAD_SUB_CHANNEL_FAILURE: "channel/LOAD_SUB_CHANNEL_FAILURE",
  ON_CHANNEL_CHANGE: "channel/ON_CHANNEL_CHANGE",
  RESET_STATE: "channel/RESET_STATE"
};

const initialState = {
  channels: {
    isLoading: false,
    ids: [],
    data: {},
    error: null
  },
  subchannels: {
    isLoading: false,
    ids: [],
    data: {},
    error: null
  }
};

export const channel = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_CHANNEL_REQUEST: {
      return { ...state, channels: { ...state.channels, isLoading: true } };
    }
    case types.LOAD_CHANNEL_SUCCESS: {
      const { ids, data } = action.payload;
      return {
        ...state,
        channels: { ...state.channels, isLoading: false, ids, data }
      };
    }
    case types.LOAD_CHANNEL_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        channels: { ...state.channels, isLoading: false, error }
      };
    }
    case types.LOAD_SUB_CHANNEL_REQUEST: {
      return {
        ...state,
        subchannels: { ...state.subchannels, isLoading: true }
      };
    }
    case types.LOAD_SUB_CHANNEL_SUCCESS: {
      const { ids, data } = action.payload;
      return {
        ...state,
        subchannels: { ...state.subchannels, isLoading: false, ids, data }
      };
    }
    case types.LOAD_SUB_CHANNEL_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        subchannels: { ...state.subchannels, isLoading: false, error }
      };
    }
    case types.ON_CHANNEL_CHANGE: {
      return {
        ...state,
        subchannels: initialState.subchannels
      };
    }
    case types.RESET_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};

export const loadChannels = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.ON_CHANNEL_CHANGE });
    dispatch({ type: types.LOAD_CHANNEL_REQUEST });
    try {
      const params: IChannelParams = {
        headers: getAnyTokenFromState(getState())
      };
      const response = await getChannelsApi(params);
      const dataArr = response.data.Data;
      const normalizedData = normalize({ data: dataArr, key: "chnlid" });
      dispatch({
        type: types.LOAD_CHANNEL_SUCCESS,
        payload: { ...normalizedData }
      });
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.LOAD_CHANNEL_FAILURE,
        payload: { error: message }
      });
    }
  };
};

export const loadSubChannelsByChannels = (data: ISubChannelActionParams) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOAD_SUB_CHANNEL_REQUEST });
    try {
      const params: ISubChannelParams = {
        headers: getAnyTokenFromState(getState()),
        chnlid: data.chnlid
      };
      const response = await getSubChannelsApi(params);
      const dataArr = response.data.Data;
      const normalizedData = normalize({ data: dataArr, key: "chnlid" });
      dispatch({
        type: types.LOAD_SUB_CHANNEL_SUCCESS,
        payload: { ...normalizedData }
      });
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.LOAD_SUB_CHANNEL_FAILURE,
        payload: { error: message }
      });
    }
  };
};

export const resetState = () => {
  return dispatch => {
    dispatch({ type: types.RESET_STATE });
  };
};